module.exports = __webpack_public_path__ + "static/media/jcb.0b914789.svg";